module.exports = __webpack_public_path__ + "img/sld_scb_13_t1_b1.bd45f7a7.svg";